export default __webpack_public_path__ + "static/media/5.81e2bd5a.svg";